import CheckGreen from "@/assets/images/checkGreen.svg";
import EyeGreen from "@/assets/images/eyeGreen.svg";
import HourglassGreen from "@/assets/images/hourglassGreen.svg";
import StarGreen from "@/assets/images/starGreen.svg";
import EmojiGreen from "@/assets/images/emojiGreen.svg";
import EmailBlue from "@/assets/images/emailBlue.svg";
import BellBlue from "@/assets/images/bellBlue.svg";
import UserIcon from "@/assets/images/userYellow.svg";
import ElseYellow from "@/assets/images/elseYellow.svg";
import ProgramYellow from "@/assets/images/programYellow.svg";
import ProgramBlue from "@/assets/images/programBlue.svg";
import TestYellow from "@/assets/images/testYellow.svg";
import TestBlue from "@/assets/images/testBlue.svg";
import VisualTestYellow from "@/assets/images/visualTestYellow.svg";
import VisualTestBlue from "@/assets/images/visualTestBlue.svg";

import PlayIcon from "@/assets/images/play.svg";
import BranchIcon from "@/assets/images/branchWhite.svg";
import LightningIcon from "@/assets/images/lightningBlue.svg";
import FilterIcon from "@/assets/images/filterYellow.svg";

export const ICON_LIST = {
    programCompleted: { icon: CheckGreen },
    programViewed: { icon: EyeGreen },
    programPending: { icon: HourglassGreen },
    reviewAdded: { icon: StarGreen },
    testCompleted: { icon: CheckGreen },
    testPending: { icon: HourglassGreen },
    visualTestCompleted: { icon: CheckGreen },
    visualTestPending: { icon: HourglassGreen },
    moodSelected: { icon: EmojiGreen },
    sendEmail: { icon: EmailBlue },
    sendNotification: { icon: BellBlue },
    assignProgram: { icon: ProgramBlue },
    assignTest: { icon: TestBlue },
    assignVisualTest: { icon: VisualTestBlue },
    waitFor: { icon: HourglassGreen },
    userCondition: { icon: UserIcon },
    programCondition: { icon: ProgramYellow },
    testCondition: { icon: TestYellow },
    visualTestCondition: { icon: VisualTestYellow },
    whenStart: { icon: PlayIcon },
    thenStart: { icon: LightningIcon },
    ifStart: { icon: FilterIcon },
    default: { icon: BranchIcon },
};

export const getUserFlowIcon = (iconName) => {
    const icon = ICON_LIST[iconName];
    if (icon) {
        return icon.icon;
    } else {
        console.warn(`Icon not found for name: ${iconName}`);
        return BranchIcon;
    }
}
